module.exports = __webpack_public_path__ + "img/offeo-8.8fcef6d1.png";